import { Outlet } from 'react-router-dom';
import MusicPlayer from '../MusicPlayer';

const RootLayout = () => {
  return (
    <>
      <MusicPlayer />
      <Outlet />
    </>
  );
};

export default RootLayout;
